module.exports = __webpack_public_path__ + "img/cgmi1-min-Mask.a23fda95.png";